import * as React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ListSubheader from "@mui/material/ListSubheader";
import Packshot from "../Popup/Packshot";
import { Card, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import "../annotator.css";

export default function GeneratePackshots({ packshots }) {
  const [text, setText] = React.useState(
    packshots.length > 1 ? "packshots" : "packshot"
  );
   //console.log(packshots)
  const useStyles = makeStyles((theme) => ({
    customWidth: {
      maxWidth: "13vw",
    },
  }));

  const classes = useStyles();

  return (
    <>
      {packshots.length > 0 && (
        <Card
          sx={{
            border: "1px solid #d7f3ff",
            borderRadius: "4px",
            width: "25%",
            cursor: "default",
            flex: "1",
            boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;",
            backgroundColor: "transparent",
          }}
        >
          <ImageList className="annotator-sidebar" sx={{ height: "205px",justifyContent:"center",margin:"0",marginTop:"0.5rem"}}>
            <ImageListItem key="Subheader" cols={2}>
              <ListSubheader
                component="div"
                style={{
                  fontSize: "0.8rem",
                  fontWeight:"500",
                  lineHeight: "1.1rem",
                  textAlign: "center",
                  backgroundColor: "#f6f8fa",
                  fontFamily: "ChalkboardSE-Regular",
                }}
              >
                {text}
              </ListSubheader>
            </ImageListItem>

            {packshots.map((packshot, index) => (
              <ImageListItem key={index}>
                <Packshot image={packshot} />
              </ImageListItem>
            ))}
          </ImageList>
        </Card>
      )}
    </>
  );
}
